import { StringKeys } from '../../resources/strings/StringKeys';

const renderEmergencyMessageContent = (
  msg,
  emergencyCreator,
  emergencyNumber,
  t,
) => {
  switch (msg.message_kind) {
    case 'defaultMessage':
    case 'defaultChat':
      return msg.content;
    case 'sosCard':
      return t(StringKeys.USER_PRESSED_THE_SOS_BUTTON, {
        user: msg.sender_first_name,
      });
    case 'incidentResolved':
      return t(StringKeys.USER_CLOSED_THE_EMERGENCY_EVENT, {
        user: msg.sender_first_name,
      });
    case 'noMovementDetectedCard':
      return t(StringKeys.USER_HAS_NOT_MOVED_FOR_SIXTY_SECONDS, {
        user: msg.sender_first_name,
      });
    case 'callingCard':
      return t(StringKeys.USER_ONE_IS_CALLING_USER_TWO, {
        userOne: msg.sender_first_name,
        userTwo: emergencyCreator,
      });
    case 'onMyWayCard':
      return t(StringKeys.USER_IS_HEADING_TO_THE_EMERGENCY_EVENT, {
        user: msg.sender_first_name,
      });
    case 'Head Impact':
      return t(StringKeys.USER_EXPERIENCED_A_DANGEROUS_HEAD_IMPACT, {
        user: msg.sender_first_name,
      });
    case 'arcFlashCard':
      return t(StringKeys.USER_EXPERIENCED_AN_ARC_FLASH, {
        user: msg.sender_first_name,
      });
    case 'Fall':
      return t(StringKeys.USER_EXPERIENCED_A_DANGEROUS_FALL, {
        user: msg.sender_first_name,
      });
    case 'ambulanceNeededCard':
      return t(StringKeys.USER_NEEDS_AN_AMBULANCE, {
        user: msg.sender_first_name,
      });
    case 'ambulanceSentCard':
      return t(StringKeys.USER_HAS_CALLED_AN_AMBULANCE, {
        user: msg.sender_first_name,
      });
    case 'myLocationCard':
    case 'myLocationCardFirst':
      return msg.address
        ? `${msg.address}`
        : msg.latitude != null && msg.longitude
          ? `${t(StringKeys.LATITUDE)}: ${msg.latitude.toPrecision(5)}, ${t(StringKeys.LONGITUDE)}: ${msg.longitude.toPrecision(5)}`
          : t(StringKeys.LOCATION_NOT_AVAILABLE);
    case 'deletedCard':
      return t(StringKeys.THIS_MESSAGE_HAS_BEEN_DELETED);
    case 'called911Card':
      return t(StringKeys.USER_HAS_CALLED_911, {
        user: msg.sender_first_name,
        medicalNumber: emergencyNumber,
      });
    case 'safeCard':
      return t(StringKeys.USER_IS_OK, { user: msg.sender_first_name });
    case 'iNeedHelpCard':
      return t(StringKeys.USER_NEEDS_HELP_AT_THEIR_LOCATION, {
        user: msg.sender_first_name,
      });
    default:
      return t(StringKeys.NA);
  }
};

export default renderEmergencyMessageContent;
